export const openTaskSidebar = {
  methods: {
    openTaskSidebar(item) {
      if (item.id && !this.$route.query.hasOwnProperty('task')) {
        this.$router.push({
          query: {
            ...this.$route.query,
            task: item.id
          }
        });
        setTimeout(() => {
          this.$root.$emit('bv::toggle::collapse', 'sidebar-right-task');
        }, 0)
      }
    },
  }
}